import {throwError as observableThrowError, of as observableOf,  Observable } from 'rxjs';
import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { ApiGatewayHelperService } from 'modules/app/services/apigateway-helper.service';
import { map, catchError } from 'rxjs/operators';
import { AppHelperService } from 'modules/app/services/app-helper.service';
import { ActivityViewHelperService } from './activity-view-helper.service';
import { XAPIDataGenerator } from 'libs-frontend-xapi/dist/js/xapidatagenerator.js';
import { AuthService } from 'modules/app/services/auth.service';
import { XAPIAnalytics } from 'libs-frontend-xapi/dist/js/xapianalytics.js';
import Raven from "raven-js";

@Injectable()
export class ProductViewService {
    constructor(
        private http: HttpClient,
        private apiGatewayHelperService: ApiGatewayHelperService,
        private appHelperService: AppHelperService,
        private activityViewHelperService: ActivityViewHelperService,
        private authService: AuthService
    ) { }

    /* Store productViewData in activityViewHelperService as it is common in both ProductView and ActivityView */
    getProductDataForTeacher(spaceId, productCode, classId?): Observable<any> {
        const productViewData = this.activityViewHelperService.getProductViewData();
        if (productViewData) {
            return observableOf(productViewData);
        } else {
            let url = `${this.apiGatewayHelperService.getApiGatewayPrefixUrl()}${spaceId}/teacher/product/${productCode}`;
            if (classId) {
                url += '/' + classId;
            }
            return this.http.get(url)
                .pipe(
                    map((response: any) => {
                        if (response && response.success === false) {
                            return response;
                        }
                        this.activityViewHelperService.setProductViewData(response);
                        return response;
                    }),
                    catchError((error: any) => {
                        this.appHelperService.navigateToDashboardApp([]);
                        return observableThrowError(error);
                    })
                );
        }
    }

    /* Store productViewData in activityViewHelperService as it is common in both ProductView and ActivityView */
    getProductDataForLearner(spaceId, productCode, classId?, folderId?): Observable<any> {
        const productViewData = this.activityViewHelperService.getProductViewData();
        if (productViewData) {
            return observableOf(productViewData);
        } else {
            let url = `${this.apiGatewayHelperService.getApiGatewayPrefixUrl()}${spaceId}/product/${productCode}`;
            if (classId) {
                url += '/' + classId;
            }
            return this.http.get(url)
                .pipe(
                    map((response: any) => {
                        if (response && response.success === false) {
                            return response;
                        }
                        // traverse TOC one level from root and get the required folder's TOC
                        if (folderId) {
                            let folderToc = response.toc.result.filter((folder) => {
                                return folder['item-code'] == folderId;
                            })[0].items;
                            response.toc.result = folderToc
                        }
                        this.activityViewHelperService.setProductViewData(response);
                        return response;
                    }),
                    catchError((error: any) => {
                        this.appHelperService.navigateToDashboardApp([]);
                        return observableThrowError(error);
                    })
                );
        }
    }
}
